import { NgModule } from '@angular/core';
import { CountdownModule } from 'ngx-countdown';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';

import { SharedModule } from '~console/app/~shared/modules/shared.module';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AuthWrapperComponent } from './components/auth-wrapper/auth-wrapper.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginComponent } from './pages/login/login.component';
import { AuthCountdownComponent } from './components/auth-countdown/auth-countdown.component';
import { ForgotPasswordFormComponent } from './components/forgot-password-form/forgot-password-form.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ResetPasswordFormComponent } from './components/reset-password-form/reset-password-form.component';
import { CompanyIdentificationFormComponent } from './components/company-identification-form/company-identification-form.component';
import { PersonalInfosFormComponent } from './components/personal-infos-form/personal-infos-form.component';
import { EmailConfirmationFormComponent } from './components/email-confirmation-form/email-confirmation-form.component';
import { NtdVerificationFormComponent } from './components/ntd-verification-form/ntd-verification-form.component';
import { NtdComponent } from './pages/ntd/ntd.component';
import { OnboardingFormComponent } from './components/onboarding-form/onboarding-form.component';
import { OnboardingLayoutComponent } from './layouts/onboarding-layout/onboarding-layout.component';
import { OnboardingFormMapDialogComponent } from './modals/onboarding-form-map-dialog/onboarding-form-map-dialog.component';
import { BillingEquipmentDeclarationFormComponent } from './components/billing-equipment-declaration-form/billing-equipment-declaration-form.component';
import { OnboardingStepperComponent } from './components/onboarding-stepper/onboarding-stepper.component';
import { OnboardingSummaryComponent } from './components/onboarding-summary/onboarding-summary.component';
import { RegistrationOtpModalComponent } from './modals/registration-otp-modal/registration-otp-modal.component';
import { ExistingCompanyModalComponent } from './modals/existing-company-modal/existing-company-modal.component';
import { AdminMigrationModalComponent } from './modals/admin-migration-modal/admin-migration-modal.component';
import { CompanyUserMigrationModalComponent } from './modals/company-user-migration-modal/company-user-migration-modal.component';
import { MigrationLayoutComponent } from './layouts/migration-layout/migration-layout.component';

const DECLARATIONS = [
  AuthLayoutComponent,
  LoginFormComponent,
  AuthWrapperComponent,
  LoginComponent,
  AuthCountdownComponent,
  ForgotPasswordFormComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  ResetPasswordFormComponent,
  ResetPasswordFormComponent,
  CompanyIdentificationFormComponent,
  PersonalInfosFormComponent,
  EmailConfirmationFormComponent,
  NtdVerificationFormComponent,
  NtdComponent,
  OnboardingFormComponent,
  OnboardingLayoutComponent,
  MigrationLayoutComponent,
  BillingEquipmentDeclarationFormComponent,
  OnboardingStepperComponent,
  OnboardingSummaryComponent,
  OnboardingFormMapDialogComponent,
  RegistrationOtpModalComponent,
  ExistingCompanyModalComponent,
  AdminMigrationModalComponent,
  CompanyUserMigrationModalComponent
];
const MODULES = [
  SharedModule,
  CountdownModule,
  MatDividerModule,
  MatStepperModule,
  MatSlideToggleModule
];

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS]
})
export class AuthModule {}
